import React, {useEffect, useMemo} from 'react';
import {IChecklistModel} from '@src/@interfaces/models/Checklist/IChecklistModel';

export function filterChecklists(
        currentStatusId: number | string,
        checklists: IChecklistModel[],
        productId?: number | string,
        displayOnlyWithType?: IChecklistModel['type'],
): IChecklistModel[] {
    return checklists.filter(item => {
        const isAllowedToDisplay = item.status_settings?.some(item => {
            return item.display_when_id === currentStatusId;
        }) === true;

        return (
                isAllowedToDisplay &&
                (item.items?.length ?? 0) > 0 &&
                (
                        displayOnlyWithType == null ||
                        item.type === displayOnlyWithType
                ) &&
                (
                        !productId ||
                        item.products?.some(({id}) => id === productId)
                )
        );
    });
}

export default function ChecklistFilter(props: {
    productId?: number | string,
    checklists: IChecklistModel[],
    displayOnlyWithType?: IChecklistModel['type'],
    currentStatusId: number | string,
    children: (list: IChecklistModel[]) => React.ReactNode,
    toggleTabVisibility?: (shouldBeVisible: boolean) => void,
}) {
    const {checklists, displayOnlyWithType, productId, currentStatusId, children} = props;

    const list = useMemo(() => {
        return filterChecklists(currentStatusId, checklists, productId, displayOnlyWithType);
    }, [checklists, currentStatusId, displayOnlyWithType, productId]);

    const {toggleTabVisibility} = props;
    useEffect(() => {
        if (toggleTabVisibility) {
            toggleTabVisibility(list.length > 0);
        }
    }, [list.length, toggleTabVisibility]);

    return <>{children(list)}</>;
}
